import classNames from "classnames";
import connectToStores from "alt-utils/lib/connectToStores";
import array from "lodash/array";
import collection from "lodash/collection";
import first from "lodash/first";
import get from "lodash/get";
import noop from "lodash/noop";
import size from "lodash/size";
import string from "lodash/string";
import PropTypes from "prop-types";
import React, { Component } from "react";

import Analytics from "../../utils/chat/Analytics";
import AuthStore from "../../stores/chat/AuthStore";
import ChatListStore from "../../stores/chat/ChatListStore";
import { history } from "../../utils/chat/chatNavigation";
import ConfigStore from "../../stores/chat/ConfigStore";
import { EVENT_ACTIONS } from "../../constants/AnalyticsConstants";
import HamburgerMenuContainer from "./HamburgerMenuContainer";
import MinimizeButtonContainer from "./MinimizeButtonContainer";
import QuestionStore from "../../stores/chat/QuestionStore";
import { PostMessage } from "../../constants/chat";

export class MaximizedView extends Component {
    constructor() {
        super();

        this.areThereAnyOpenQuestions = this.areThereAnyOpenQuestions.bind(this);
        this.onProcessPostMessage = this.onProcessPostMessage.bind(this);
    }

    componentDidMount() {
        window.addEventListener("message", this.onProcessPostMessage);
        Analytics.sendGaEvent({ action: EVENT_ACTIONS.MaximizedViewDisplayed });
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.onProcessPostMessage);
    }

    static getStores() {
        return [AuthStore, ChatListStore, ConfigStore, QuestionStore];
    }

    static getPropsFromStores() {
        return {
            disableAskNewQuestionFromUi: ConfigStore.getConfig().disableAskNewQuestionFromUi,
            isLoggedIn: AuthStore.getState().isLoggedIn,
            openChatList: ChatListStore.getState().openChatList,
            question: QuestionStore.getQuestion(),
        };
    }

    onProcessPostMessage({ data: { action, params } }) {
        const { disableAskNewQuestionFromUi } = this.props;

        switch (action) {
            case PostMessage.MINIMIZE: {
                history.push("minimized");
                break;
            }
            case PostMessage.MAXIMIZE_ASK_QUESTION: {
                if (disableAskNewQuestionFromUi && this.areThereAnyOpenQuestions()) return;

                history.push("ask");
                break;
            }
            case PostMessage.NAVIGATE: {
                if (disableAskNewQuestionFromUi && first(params) === "ask" && this.areThereAnyOpenQuestions()) return;

                history.push(first(params));
                break;
            }
            default: {
                noop();
            }
        }
    }

    areThereAnyOpenQuestions() {
        const questionIsOpen = get(this.props.question, "status") === 0;
        const openQuestionCount = size(this.props.openChatList);

        return questionIsOpen || openQuestionCount > 0;
    }

    render() {
        const { header, isLoggedIn, location, main } = this.props;
        const listRouteIsActive = collection.includes(location.pathname, "/list");
        const viewFromPathname = array.nth(string.split(location.pathname, "/"), 1);
        const maximizedViewClasses = classNames({
            "maximized-view": true,
            [`is-${viewFromPathname}-view`]: true,
        });

        return (
            <div className={maximizedViewClasses}>
                <div className="header-container">
                    {isLoggedIn && <HamburgerMenuContainer isDisabled={listRouteIsActive} />}
                    {header}
                    <MinimizeButtonContainer />
                </div>
                {main}
            </div>
        );
    }
}

MaximizedView.defaultProps = {
    openChatList: [],
};

MaximizedView.propTypes = {
    disableAskNewQuestionFromUi: PropTypes.bool.isRequired,
    header: PropTypes.element.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    location: PropTypes.shape({}).isRequired,
    main: PropTypes.element.isRequired,
    openChatList: PropTypes.arrayOf(PropTypes.shape({})),
    question: PropTypes.shape({}).isRequired,
};

export default connectToStores(MaximizedView);
